import type { ArbitraryTypedObject, PortableTextBlock } from '@portabletext/types';
import { ChangelogEntryDTO, ChangelogTag } from '../dto';

export interface ChangelogEntryProps {
  id: string;
  title: string;
  content: (PortableTextBlock | ArbitraryTypedObject)[];
  changeDate: string;
  tags: ChangelogTag[];
  seen: boolean;
}

export class ChangelogEntry {
  id: string;
  title: string;
  content: (PortableTextBlock | ArbitraryTypedObject)[];
  changeDate: string;
  tags: ChangelogTag[];
  seen: boolean;

  constructor(props: ChangelogEntryProps) {
    this.id = props.id;
    this.title = props.title;
    this.content = props.content;
    this.changeDate = props.changeDate;
    this.tags = props.tags;
    this.seen = props.seen;
  }

  static fromDto = (dto: ChangelogEntryDTO, seen: boolean) =>
    new ChangelogEntry({
      ...dto,
      tags: dto.tags ?? [],
      seen,
    });
}
